import React from 'react';
import { CTAButton, scrollToPricing } from './CTAButton';
import { TrustBar } from './TrustBar';
import { productImage } from '../data/content';
export function Hero() {
  return <header className="bg-brand-navy px-4 py-4 text-center text-white sm:px-6 sm:py-5" data-id="element-78" data-mp="9ktf7r44e8zc">
      <h1 className="mx-auto mb-1.5 max-w-2xl text-[21px] font-extrabold uppercase leading-[1.1] sm:text-[34px]" data-id="element-79" data-mp="9ih0rnxkmgr1">
        Il Sistema Completo di Pianificazione per{' '}
        <span className="text-brand-green" data-id="element-80" data-mp="128pixfs3x15m">Istruttori e Maestri di Padel</span>
      </h1>
      <p className="mx-auto mb-2.5 max-w-xl text-[12.5px] font-medium leading-snug text-white/90 sm:text-[15px]" data-id="element-81" data-mp="xaxfppm0hsm4">
        Risparmia ore ogni settimana preparando lezioni, esercizi, progressioni, programmi e
        strumenti di coaching, senza dover creare tutto da zero ogni volta.
      </p>
      <button type="button" onClick={scrollToPricing} className="mb-2.5 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Vai alla sezione di acquisto" data-id="element-82" data-mp="3d2bhzk51cpsw">
        <img src={productImage} alt="PADEL MASTER PRO — sistema completo 6-in-1 per istruttori e maestri di padel" className="mx-auto w-full max-w-[290px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02] sm:max-w-[380px]" data-id="element-83" data-mp="3j9aldp7jncay" />
      </button>
      <div className="mx-auto mb-2 max-w-md" data-id="element-84" data-mp="30iayquniueku">
        <CTAButton data-id="element-85" data-mp="30ggfdkrweuiv">🚀 SÌ! VOGLIO PADEL MASTER PRO™ ORA</CTAButton>
      </div>
      <TrustBar data-id="element-86" data-mp="359t03jtgih6c" />
    </header>;
}